module.exports = __webpack_public_path__ + "static/media/coin.40b16c7e.gif";